import { route } from '../helpers';
import { PromotionPages } from '../../constants/AppConstants';

module.exports = route(PromotionPages.TOC_FAMILY_VERIFY, {
    getComponent(location, cb) {
        require.ensure(
            [],
            require => {
                cb(null, require('../../components/promotion/TOCFamilyVerify').default);
            },
            'promotion-toc-family-verify',
        );
    },
});



// WEBPACK FOOTER //
// ./src/routes/Promotion/Verify.js